import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Box, useTheme, makeStyles } from '@material-ui/core';

import { getInsuranceLocalInfo } from '../../utils';
import { setSelectedInsurance } from '../../redux/InsuranceTypes';
import { activeInsurances } from '../../config';
import Bubble from '../../components/Bubble';

const useStyles = makeStyles({
  scale: {
    transform: 'scale(1.2)',
  },
  imageContainer: {
    cursor: 'pointer',
  },
});

export default function InsuranceCard({
  insuranceId,
  insuranceName,
  insuranceCompany,
}) {
  const theme = useTheme();
  const classes = useStyles();

  const [hover, setHover] = useState(false);

  const history = useHistory();
  const dispatch = useDispatch();

  const { user } = useSelector(({ user }) => ({
    user,
  }));

  const insuranceInfo = getInsuranceLocalInfo(insuranceName);
  const active = activeInsurances.includes(insuranceName);

  const hasSubProducts = insuranceCompany.products.length > 1;

  const handleOnclick = () => {
    if (!active) return;
    if (user.empleado && insuranceName === 'ROBO EN CAJERO AUTOMATICO') return;
    dispatch(
      setSelectedInsurance({
        insuranceId,
        insuranceName,
        insuranceCompany,
        insuranceProductId:
          !hasSubProducts && insuranceCompany.products[0].productId,
        ...insuranceInfo,
      })
    );

    if (insuranceName === 'INTEGRAL DE COMERCIO') {
      history.push(`${insuranceInfo.url}/actividad`);
    } else if (insuranceName === 'AUTOMOTOR') {
      history.push(`${insuranceInfo.url}/cotizacion`);
    } else {
      const url = hasSubProducts
        ? `${insuranceInfo.url}/opciones`
        : `${insuranceInfo.url}/planes`;
      history.push(url);
    }
  };

  const bgColor =
    active && hover
      ? theme.palette.secondary.main
      : active
      ? theme.palette.primary.main
      : theme.palette.gray['700'];

  return (
    <div style={{ position: 'relative' }}>
      {hover &&
        user.empleado &&
        insuranceName === 'ROBO EN CAJERO AUTOMATICO' && (
          <Bubble name={user.nombre} />
        )}
      <Box
        width='102px'
        display='flex'
        alignItems='center'
        flexDirection='column'
        className={hover ? classes.scale : ''}
      >
        <Box
          width='100px'
          height='100px'
          borderRadius='7%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          zIndex='tooltip'
          bgcolor={bgColor}
          onMouseEnter={() => active && setHover(true)}
          onMouseLeave={() => active && setHover(false)}
          onClick={handleOnclick}
          className={classes.imageContainer}
        >
          <Box textAlign='center'>
            <Box textAlign='center'>
              <img
                src={insuranceInfo.logo}
                alt={insuranceName}
                style={{ height: '100%' }}
              />
            </Box>
          </Box>
        </Box>
        <Box
          component='p'
          fontSize={14}
          fontWeight={hover ? 700 : 400}
          color={
            active ? theme.palette.primary.main : theme.palette.gray['700']
          }
          textAlign='center'
        >
          {insuranceName}
        </Box>
      </Box>
    </div>
  );
}
